import { type PropertyValue } from 'api/clients/PropertyClient'
import { ReactComponent as Chevron } from 'assets/icons/chevron-right--small__16.svg'
import { PropertyValuePill } from '../PropertyValuePill/PropertyValuePill'
import Styles from './Transition.module.scss'

interface Props {
  from: PropertyValue
  to: PropertyValue
}

export const Transition = ({ from, to }: Props) => (
  <>
    <PropertyValuePill propertyValue={from} />
    <Chevron className={Styles.chevron} />
    <PropertyValuePill propertyValue={to} />
  </>
)
